var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useMemo } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { ErrorBoundary } from '@web/utils';
import { useBlockSection } from '../BlockSection';
import { usePageEdit } from '../../../ModulePage';
import { useBlockEdit, useBlock, BlockControlsBottom } from '../../';
import { BlockWrapper, BlockControlsTop } from '../../../ModuleBlock';
import { useTheme } from '@web/theme';
export var BlockDraggable = memo(function (_a) {
    var _b, _c, _d, _e, _f;
    var id = _a.id, index = _a.index, children = _a.children;
    var theme = useTheme();
    var blockSectionId = useBlockSection().blockSectionId;
    var pageEdit = usePageEdit().pageEdit;
    var block = useBlock(id).block;
    var blockEdit = useBlockEdit().blockEdit;
    var dragDisabled = useMemo(function () { return !pageEdit.enabled || blockEdit.dragDisabled; }, [pageEdit.enabled, blockEdit.dragDisabled]);
    var useShadow = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b.shadow) !== undefined ? blockEdit.data.shadow : block === null || block === void 0 ? void 0 : block.shadow;
    var useMargin = !blockEdit.enabled && (((_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c.margin) !== undefined ? blockEdit.data.margin : block === null || block === void 0 ? void 0 : block.margin);
    var useColor = ((_d = blockEdit.data) === null || _d === void 0 ? void 0 : _d.color) || (block === null || block === void 0 ? void 0 : block.color);
    var useBg = ((_e = blockEdit.data) === null || _e === void 0 ? void 0 : _e.bg) || (block === null || block === void 0 ? void 0 : block.bg);
    var useBox = ((_f = blockEdit.data) === null || _f === void 0 ? void 0 : _f.box) || (block === null || block === void 0 ? void 0 : block.box);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Draggable, { draggableId: blockSectionId + "-" + index + "-" + id, index: index, isDragDisabled: !!dragDisabled }, function (provided, snapshot) { return (React.createElement(React.Fragment, null,
            React.createElement(BlockWrapper, __assign({ color: useColor || theme.accent3rd.txt, bg: block ? useBg || theme.accent3rd.bg : 'transparent', shadow: useShadow, margin: useMargin, box: useBox, ref: provided.innerRef }, provided.draggableProps),
                React.createElement(BlockControlsTop, __assign({ id: id }, provided.dragHandleProps)),
                children,
                block && React.createElement(BlockControlsBottom, { id: id })))); })));
});
